import { SITE_CONFIG } from "../app/config";
import { useHead } from "../seo/useHead";

type LegalLayoutProps = {
  title: string;
  description?: string;
  path: string;
  children: React.ReactNode;
};

export const LegalLayout = ({ title, description, path, children }: LegalLayoutProps): JSX.Element => {
  useHead({
    title,
    description: description ?? `${title} for ${SITE_CONFIG.name}. Last updated: ${SITE_CONFIG.lastUpdated}.`,
    path,
    noIndex: true,
  });

  return (
  <div className="shell">
    <div className="legal-page">
      <header className="legal-header">
        <a href="/" className="legal-back">← Back to {SITE_CONFIG.name}</a>
        <h1 className="legal-title">{title}</h1>
        <p className="legal-updated">Last updated: {SITE_CONFIG.lastUpdated}</p>
      </header>
      <article className="legal-content">
        {children}
      </article>
      <footer className="legal-footer">
        <a href="/">← Return to {SITE_CONFIG.name}</a>
      </footer>
    </div>
  </div>
  );
};
